module.exports = __webpack_public_path__ + "img/2024big29.d543e16c.png";